export default "__VITE_ASSET__DpcJnAwK__"